import { render, staticRenderFns } from "./BulletsToc.vue?vue&type=template&id=2b479dc1&"
import script from "./BulletsToc.vue?vue&type=script&lang=js&"
export * from "./BulletsToc.vue?vue&type=script&lang=js&"
import style0 from "./BulletsToc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports